import { PATH_ROUTES } from "../router/routes";

export interface SidebarContent {
  question: string;
  periodYears: string;
  dimensions: string[];
  fontSources: string[];
}

export interface ModulePageConfig {
  title: string;
  sidebar: SidebarContent;
}

export const MODULE_PAGE_CONFIG: Record<string, ModulePageConfig> = {
  [PATH_ROUTES.home]: {
    title: "Tendències titulacions en el temps",
    sidebar: {
      question:
        "Compara les titulacions universitàries ofertes a Catalunya amb les de les 5 principals universitats d'Europa i la resta d'Espanya, i identifica les tendències.",
      periodYears: "15 anys",
      dimensions: [
        "Arts i humanitats",
        "Ciències",
        "Ciències de la salut",
        "Socials",
        "Juridiques",
        "Enginyeria",
        "Arquitectura",
      ],
      fontSources: ["fuente 1"],
    },
  },
  [PATH_ROUTES.professionsRegulades]: {
    title: "Ràtio professionals titulats en professions regulades",
    sidebar: {
      question:
        "Com es posiciona Catalunya en la ràtio de professionals procedents de titulacions que habiliten per a l'exercici de professions regulades, en comparació amb altres països europeus?",
      periodYears: "15 anys",
      dimensions: ["Professions regulades", "País/sistema", "Any"],
      fontSources: ["fuente 1", "fuente 2"],
    },
  },
  [PATH_ROUTES.professionalsSanitaris]: {
    title: "Projecció de demanda futura de professionals del sector sanitari",
    sidebar: {
      question:
        "Analitzar la demanda de professionals a Catalunya, concretament al sector sanitari, durant els propers 10 a 20 anys, tenint en compte l'evolució demogràfica i l'índex d'envelliment (jubilacions).",
      periodYears: "20 anys",
      dimensions: ["Sanitaris", "Any"],
      fontSources: ["fuente 1", "fuente 2", "fuente 3", "fuente 4", "fuente 5", "fuente 6"],
    },
  },
  [PATH_ROUTES.ofertaUniversitaria]: {
    title: "Projecció de demanda futura de professionals del sector sanitari",
    sidebar: {
      question:
        "Quines titulacions universitàries a Catalunya presenten els indicadors més crítics de desajust laboral, definits com la combinació d'una baixa taxa d'ocupació, un alt percentatge de sobrequalificació (graduats en feines que no requereixen titulació) i una baixa adequació de la feina a la titulació?",
      periodYears: "15 anys",
      dimensions: ["Màsters", "Doctorats"],
      fontSources: ["fuente 1", "fuente 2", "fuente 3", "fuente 4", "fuente 5", "fuente 6"],
    },
  },
  [PATH_ROUTES.desajustTitulacio]: {
    title: "Oferta universitària i de recerca vs. sectors productius a Catalunya",
    sidebar: {
      question:
        "Quines titulacions universitàries a Catalunya presenten els indicadors més crítics de desajust laboral, definits com la combinació d'una baixa taxa d'ocupació, un alt percentatge de sobrequalificació (graduats en feines que no requereixen titulació) i una baixa adequació de la feina a la titulació?",
      periodYears: "Any actual",
      dimensions: ["Comarca", "Ambit del sector", "Tipologia de recerca", "Titulacions universitàries"],
      fontSources: ["fuente 1", "fuente 2", "fuente 3", "fuente 4"],
    },
  },
};

export const getModuleConfig = (path: string): ModulePageConfig =>
  MODULE_PAGE_CONFIG[path] ?? MODULE_PAGE_CONFIG[PATH_ROUTES.home];
